import * as React from "react";
import Grid from "@mui/material/Grid";
import { CmpTypographyField } from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { Button } from "react-bootstrap";
export const Detail = ({ data = [], onClick = () => {}, vMediaQuery }) => {
  return (
    <Box sx={{ display: "flex" }}>
      <Grid container spacing={1}>
        {data.map((item, index) => (
          <Grid
            item
            xs={12}
            sm={4}
            md={3}
            key={index}
            onClick={() => {
              let items = { row: item };
              onClick(items);
            }}
          >
            {/* <div className="easy-putaway-card">
            <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>
              <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
                  SrNo
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" className="value">
                  {item.LI_SrNo}
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
                 Qty
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" className="value">
                  {item.LI_Qty}
                </Typography>
              </Grid>
             
              <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
                Unit
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" className="value">
                  {item.LI_UnitName}
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
                BaseQty
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" className="value">
                  {item.LI_BaseQty}
                </Typography>
              </Grid>
            </Grid>
          </div> */}
            <Card
              sx={{
                width: "100%",
                borderRadius: 3,
                boxShadow: 2,
                border: "1px solid #FAF9F6",
                "& .MuiCardContent-root": {
                  padding: "10px !important",
                },
              }}
            >
              <CardContent>
                {/* Title Section */}
                <Typography
                  variant={vMediaQuery ? "subtitle2" : "subtitle1"}
                  fontWeight="bold"
                  fontSize={vMediaQuery ? "14px" : "16px"}
                >
                  SrNo: {item?.LI_SrNo}
                </Typography>

                <Box
                  sx={{
                    backgroundColor: "#F4F4F4",
                    borderRadius: 2,
                    p: "10px",
                    mt: 0.5,
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={4}>
                      <Typography variant="caption" color="gray">
                        Qty
                      </Typography>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {item.LI_Qty}
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography variant="caption" color="gray">
                      UnitName
                      </Typography>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {item.LI_UnitName}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography variant="caption" color="gray">
                        BaseQty
                      </Typography>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {item.LI_BaseQty}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
